/**
 * Locale-aware currency display.
 *
 * Default: **EUR (€)** for every region — KeepSoul charges in euros via Stripe.
 * The user can override to "USD" via `localStorage.ks_currency = 'USD'` if needed
 * (kept for legacy compatibility, no FX conversion is performed — symbol swap only).
 */
function detectCurrency() {
  try {
    const override = (localStorage.getItem("ks_currency") || "").toUpperCase();
    if (override === "USD" || override === "EUR") return override;
  } catch { /* ignore */ }
  return "EUR";
}

export function useCurrency() {
  const currency = detectCurrency();
  const symbol = currency === "USD" ? "$" : "€";
  return {
    currency,
    symbol,
    /** Format an amount keeping the same numeric value but swapping the symbol. */
    format(amount, { decimals } = {}) {
      const n = Number(amount) || 0;
      const dp = typeof decimals === "number" ? decimals : (Number.isInteger(n) ? 0 : 2);
      return `${symbol}${n.toFixed(dp)}`;
    },
  };
}

/** Convenience component for `<Price amount={3.99} />` → `€3.99` or `$3.99` */
export default function Price({ amount, decimals, suffix }) {
  const { format } = useCurrency();
  return (
    <span data-testid="price">
      {format(amount, { decimals })}
      {suffix ? <span>{suffix}</span> : null}
    </span>
  );
}
